import type { CompliancePageKind } from 'shared';

/**
 * Shared between the public CompliancePage.tsx (route-facing kebab-case
 * kind) and the staff CompliancePagesPage.tsx editor (DB SCREAMING_SNAKE_CASE
 * kind), so the two never drift apart. Titles are fixed in code — only the
 * body content is admin-editable, per this feature's own scope.
 */
export const COMPLIANCE_PAGE_TITLES: Record<CompliancePageKind, string> = {
  COMPLIANCE: 'Compliance',
  PRIVACY_POLICY: 'Privacy Policy',
  TERMS_OF_USE: 'Terms of Use',
  EQUAL_HOUSING: 'Equal Housing Opportunity',
};
